import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import no_image_available from "../../assets/images/no_image_available.png";
import { useParams } from 'react-router-dom';
import { bannerService } from '../../services/bannerService';
import { urlConfig } from '../../config/baseUrl';
import BackButton from '../../components/common/BackButton';

const BannerDetails = () => {

  const { t } = useContext(LocaleContext);
  const { id } = useParams();
  const [loading,setLoading]=useState(false);
  const [data,setData]=useState(null);

  useEffect(() => {
      getDetails();
  },[])

  const getDetails=async()=>{
    try {
        var res = await bannerService.getDetails(id);
        console.log(res);
        setData(res.value);
    } catch (error) {
        console.log(error);
    }

  }

  return (
    <section className="section-banner-details">
      <div className="default-heading">{t("banners")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("bannerDetails")}
          <BackButton />
        </div>
        <div className="my-card-body">
          <div className="banner-image-box">
            <img src={data?.imagePath ? urlConfig.imageBaseUrl +"/"+ data?.imagePath : no_image_available} alt="Banner Image" />
          </div>

          <div className="my-card mt-3">
            <div className="my-card-header">{t("information")}</div>
            <div className="my-card-body">
              <div className="my-list-items">
                <div className="my-list-item">
                  <strong>{t("title")}</strong>
                  <span>{data?.title}</span>
                </div>
                 <div className="my-list-item">
                  <strong>{t("titleEn")}</strong>
                  <span>{data?.titleEn}</span>
                </div>
                 <div className="my-list-item">
                  <strong>{t("subTitle")}</strong>
                  <span>{data?.subtitle}</span>
                </div>
                 <div className="my-list-item">
                  <strong>{t("subTitleEn")}</strong>
                  <span>{data?.subtitleEn}</span>
                </div>
                <div className="my-list-item">
                  <strong>{t("noOfTrips")}</strong>
                  <span>{data?.noOfTrips}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BannerDetails